import { Component, OnInit } from '@angular/core';
import {EmpresasService} from "../../../superadmin/services/empresas.service";
import {ConstantsService} from "../../ConstantsService";

@Component({
  selector: 'app-tela-configuracao-temas',
  templateUrl: './tela-configuracao-temas.component.html',
  styleUrls: ['./tela-configuracao-temas.component.scss']
})
export class TelaConfiguracaoTemasComponent implements OnInit {
  empresa: any;
  ativando = false;

  constructor(private empresasService: EmpresasService, private constantsService: ConstantsService) {

  }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if (!empresa) return;

      this.empresa = empresa;
    });
  }

  ativarTema(tema: string) {
    this.ativando = true;
    this.empresasService.ativarTema(true, tema).then ( () => {
      this.ativando = false;
      this.empresa.tema = tema;
    }).catch( (erro) => {
      this.ativando = false;
    });
  }

  desativarTema() {
    this.ativando = true;
    this.empresasService.ativarTema(false, '').then(() => {
      this.ativando = false;
      this.empresa.tema = null;
    }).catch( (erro) => {
      this.ativando = false;
    });
  }
}
